"use strict";
exports.__esModule = true;
var ChartBreakdownRequest_1 = require("../entity/ChartBreakdownRequest");
var convertDimensionStateToRequest = function (chartDimensionStates) {
    var DELETE = 'DELETE';
    return chartDimensionStates
        ? chartDimensionStates
            .map(function (dimensionState) {
            if (dimensionState.breakdown.isSelected) {
                return ChartBreakdownRequest_1["default"].fromJSON({
                    breakdown: dimensionState.breakdown.value,
                    filter: dimensionState.filter
                        .map(function (item) {
                        if (item.isSelected) {
                            return item.value;
                        }
                        else
                            return DELETE;
                    })
                        .filter(function (item) { return item !== DELETE; })
                });
            }
            else
                return new ChartBreakdownRequest_1["default"]({ breakdown: DELETE });
        })
            .filter(function (item) { return item.breakdown !== DELETE; })
        : [];
};
exports["default"] = convertDimensionStateToRequest;
